import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_9 = ["src", "usemap"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["coords", "onClick"]
const _hoisted_12 = { class: "bg-white border-project border-4 rounded-sm flex flex-col relative max-w-4xl" }
const _hoisted_13 = { class: "p-4 flex flex-col items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: "img/gograss/wow.png" }, null, -1)
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-6 main-content", _ctx.config.classes?.mainClasses])
          }, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.TR(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.TR(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "mt-4",
                  innerHTML: _ctx.TR(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.config.textPart4)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  class: "mt-4",
                  innerHTML: _ctx.TR(_ctx.config.textPart4, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.config.image1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: _ctx.config.image1,
                    class: "w-full",
                    alt: "Logo",
                    usemap: `#${_ctx.imageMapId}`
                  }, null, 8, _hoisted_9),
                  (_ctx.config.image1Map)
                    ? (_openBlock(), _createElementBlock("map", {
                        key: 0,
                        id: _ctx.imageMapId,
                        name: "image-map"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.image1Map, (area) => {
                          return (_openBlock(), _createElementBlock("area", {
                            key: area.next,
                            shape: "rect",
                            alt: "",
                            title: "",
                            coords: area.coords,
                            href: "#",
                            target: "",
                            onClick: _withModifiers(($event: any) => (_ctx.goTo(area.next)), ["prevent"])
                          }, null, 8, _hoisted_11))
                        }), 128))
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.buttons)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  class: _normalizeClass(["mt-12 py-2", _ctx.config.classes?.buttonsClasses])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.buttons, (text, link) => {
                    return (_openBlock(), _createBlock(_component_ActionButton, {
                      key: text,
                      class: "mt-2 mr-2",
                      "color-class": "action-button-project2",
                      text: text,
                      onClick: ($event: any) => (_ctx.onButtonClick(link))
                    }, null, 8, ["text", "onClick"]))
                  }), 128))
                ], 2))
              : (_ctx.config.nextButtonText)
                ? (_openBlock(), _createBlock(_component_ActionButton, {
                    key: 7,
                    class: "mt-12",
                    "color-class": "action-button-project2",
                    text: _ctx.config.nextButtonText,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNextLink()))
                  }, null, 8, ["text"]))
                : (_openBlock(), _createBlock(_component_BackNextButtons, {
                    key: 8,
                    "button-class": "action-button action-button-project2 mt-12 mb-8",
                    "go-to": _ctx.goTo,
                    "next-screen": _ctx.config.screenNext
                  }, null, 8, ["go-to", "next-screen"]))
          ], 2),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["col-span-2 h-full min-h-75vh flex-col items-center flex", _ctx.config.classes.rightSide]),
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: contain; background-position: center; background-repeat: no-repeat; ${_ctx.config.bgStyles}`)
              }, null, 6))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Modal, {
          modelValue: _ctx.showModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showModal = false; _ctx.next()}),
                class: "absolute top-2 right-4 text-project font-bold text-3xl text-right"
              }, " × "),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.config.popupTexts, (text) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: text,
                    class: "mt-8",
                    innerHTML: _ctx.TR(text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_15))
                }), 128)),
                _createVNode(_component_ActionButton, {
                  text: "buttons.close",
                  "button-class": "action-button mt-4",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false))
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}